import React from 'react';
import styled from 'styled-components';
import { node, string, func, shape, bool } from 'prop-types';
import { GEL_SPACING_HLF, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { getBrevier } from '@bbc/gel-foundations/typography';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';
import { C_LUNAR, C_METAL } from '@bbc/psammead-styles/colours';
import { getSansRegular } from '@bbc/psammead-styles/font-styles';
var PADDING = "\n  padding-bottom: ".concat(GEL_SPACING_HLF, ";\n  &:last-child {\n    padding-bottom: ").concat(GEL_SPACING_DBL, ";\n  }\n");
var StyledTimestamp = /*#__PURE__*/styled.time.withConfig({
  displayName: "StyledTimestamp",
  componentId: "um718p-0"
})(["", " color:", ";display:block;", " ", ""], function (_ref) {
  var script = _ref.script,
      typographyFunc = _ref.typographyFunc;
  return script && typographyFunc && typographyFunc(script);
}, function (_ref2) {
  var darkMode = _ref2.darkMode;
  return darkMode ? C_LUNAR : C_METAL;
}, function (_ref3) {
  var service = _ref3.service;
  return getSansRegular(service);
}, function (props) {
  return props.padding && PADDING;
});

var Timestamp = function Timestamp(_ref4) {
  var children = _ref4.children,
      datetime = _ref4.datetime,
      typographyFunc = _ref4.typographyFunc,
      script = _ref4.script,
      padding = _ref4.padding,
      service = _ref4.service,
      darkMode = _ref4.darkMode;
  return /*#__PURE__*/React.createElement(StyledTimestamp, {
    dateTime: datetime,
    typographyFunc: typographyFunc,
    script: script,
    padding: padding,
    service: service,
    darkMode: darkMode
  }, children);
};

Timestamp.defaultProps = {
  typographyFunc: getBrevier,
  padding: true,
  darkMode: false
};
Timestamp.propTypes = {
  children: node.isRequired,
  datetime: string.isRequired,
  typographyFunc: func,
  padding: bool,
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  darkMode: bool
};
export default Timestamp;